<template>
  <div
    @click="$emit('openModal')"
    class="custom-container my-0 mx-auto"
  >
    <div class="overlay-block">
      <div class="overlay-block__area" />
      <span class="overlay-block__box">
        <img
          class="overlay-block__icon"
        >
        <div>
          <v-icon>{{ mdiPencil }}</v-icon> Zona editable
        </div>
      </span>
    </div>
    <div
      class="py-4 px-9"
    >
      <div class="py-0 px-3 my-0 mx-auto text-center">
        <p v-html="messageToHTML(text)" />
      </div>
    </div>
  </div>
</template>
<script>
import { mdiPencil } from '@mdi/js';
import { messageToHTML } from '@app/composables/useMessageToHTML';

export default {
  props: {
    text: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      mdiPencil,
    };
  },
  methods: {
    messageToHTML,
  },
};
</script>

<style lang="scss" scoped>
.overlay-block {
  display: none;
  z-index: 99;
  position: absolute;
  height: 100%;
  width: 100%;
  cursor: pointer;

  &__area {
    height: 100%;
    width: 100%;
    border: 3px solid #1b61e4;
    background-color: #f7f7f7;
    opacity: .8;
    z-index: 9999;
  }

  &__icon {
    color: #000;
    height: 15%;
    width: 10%;
    top: 60%;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  &__box {
    color: #000;
    padding: 6px 10px 6px 55px;
    font-size: 20px;
    position: absolute;
    top: 22%;
    left: 27%;
    right: 27%;
    border: 1px solid transparent;
    border-radius: 4px;
    display: flex;
  }
}

.custom-container {
  color: #212121;
  font-size: 18px;
  width: auto;
  background-color: #f7f7f7;
  position: relative;
}

</style>
